import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { tracker } from 'app-components/utils/core';
import kbb from 'assets/logos/kbb-logo.png';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ZillowImage, ZillowTerms } from './Property/utils';

const useStyles = makeStyles()((theme) => ({
  root: {
    height: 535,
  },
  loadingCircle: {
    display: 'block',
    margin: 'auto',
    position: 'relative',
    color: theme.palette.primary.main,
  },
  headlineIcon: {
    paddingTop: 80,
    height: 115,
  },
  alignCenter: {
    textAlign: 'center',
    padding: 40,
    marginBottom: 46,
  },
  findingTextClass: {
    paddingBottom: 30,
  },
  downloadingDataText: {
    display: 'flex',
    paddingTop: 14,
    justifyContent: 'center',
  },
  zillowLegalText: {
    color: theme.palette.text.secondary,
  },
}));

const LoadingInfo = (props: { realestate: boolean }) => {
  const { realestate } = props;
  const { classes } = useStyles();

  return (
    <DialogContent className={classes.root}>
      <div className={classes.alignCenter}>
        <Typography variant='headlineMedium' className={classes.findingTextClass}>
          Finding Your {realestate ? 'Home' : 'Vehicle'}
        </Typography>
        <CircularProgress size={130} className={classes.loadingCircle} />
        <div className={classes.downloadingDataText}>
          <Typography>Downloading data...</Typography>
        </div>
        {realestate ? (
          ZillowImage(classes.headlineIcon, tracker.events.zillowUX_3)
        ) : (
          <img className={classes.headlineIcon} src={kbb} alt='' />
        )}
      </div>
      {realestate && ZillowTerms(classes.zillowLegalText, tracker.events.zillowUX_3)}
    </DialogContent>
  );
};

export default LoadingInfo;
